import keyMirror from "fbjs/lib/keyMirror";

export const ActionTypes = keyMirror({
  SHOW_SPINNER: undefined,
  HIDE_SPINNER: undefined
});
